export default (props) => (
  <svg {...props} viewBox="0 0 120 120" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="m0 0h120v120h-120z" />
      <path
        d="m3.66666667 0h22.61111113c1.1541101 0 2.2408673.50194798 2.9333333 1.35483871l5.1333333 6.32258064c.6924661.85289073 1.7792233 1.35483871 2.9333334 1.35483871h47.0555555c2.0250441 0 3.6666667 1.51645494 3.6666667 3.38709674v54.1935484c0 1.8706419-1.6416226 3.3870968-3.6666667 3.3870968h-80.66666663c-2.02504403 0-3.66666667-1.5164549-3.66666667-3.3870968v-63.22580643c0-1.87064183 1.64162264-3.38709677 3.66666667-3.38709677z"
        fillRule="nonzero"
        stroke="currentColor"
        strokeWidth="6"
        transform="translate(16 21)"
      />
      <circle
        cx="90"
        cy="90"
        fill="#FD4329"
        r="19.5"
        stroke="#fff"
        strokeWidth="3"
      />
      <g fill="#fff" fillRule="nonzero" transform="translate(88 78)">
        <path d="m1.14151129 13.5985462c.27477919 1.0669628 2.22021589 1.0694241 2.49813542.0024612l1.16035329-11.71936242c0-1.03865818-1.07399411-1.88164498-2.39921492-1.88164498-1.3252208 0-2.40078508.8429868-2.40078508 1.88164498z" />
        <path d="m2.23814464 19.2c-1.23478791 0-2.23814464 1.0743455-2.23814464 2.4s1.00335673 2.4 2.23814464 2.4h.32371072c1.23625267 0 2.23814464-1.0743455 2.23814464-2.4s-1.00189197-2.4-2.23814464-2.4z" />
      </g>
    </g>
  </svg>
);
